export const WORKSPACE_DEFAULT_WIDTH = 360;
export const WORKSPACE_MIN_WIDTH = 300;

/** Width of the pull-open handle strip left visible after drag-to-close. */
export const PANEL_COLLAPSED_HANDLE_WIDTH = 12;

/** Inset from the workspace content edge to the canvas panel (Tailwind `right-2`). */
export const WORKSPACE_PANEL_EDGE_PADDING = 8;
/**
 * ui2026 surface gutter (Tailwind `px-1` / `pb-1` / `gap-1`) — matches board/search chrome beside
 * the agent panel and the asset modal's outer inset.
 */
export const WORKSPACE_UI2026_SURFACE_GAP = 4;

// Horizontal padding inside the canvas container (px-2 = 8px on each side)
export const WORKSPACE_CANVAS_HORIZONTAL_PADDING = 16;

export const WORKSPACE_AGENT_PANEL_DEFAULT_WIDTH = 400;
export const WORKSPACE_AGENT_PANEL_MIN_WIDTH = 280;
export const WORKSPACE_AGENT_PANEL_MAX_WIDTH = 480;

/** Strato floating card height after undocking from an edge (`E2_FLOATING_PANEL_HEIGHT`). */
export const WORKSPACE_AGENT_PANEL_DEFAULT_FLOAT_HEIGHT = 400;
/** Smallest floating card the prototype will shrink to. */
export const WORKSPACE_AGENT_PANEL_MIN_HEIGHT = 240;
